import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import NavBar from "../components/NavBar";
import NavBarExt from "../components/NavBarExt";
import { isLoggedInUserInfo } from "./AuthState";

function ExternalRoutes() {
  const { userInformation } = useContext(UserContext);
  const isLoggedIn = isLoggedInUserInfo(userInformation);

  return (
    <>
      {isLoggedIn ? <NavBar /> : <NavBarExt />}
      <Outlet />
    </>
  );
}

export default ExternalRoutes;
